module.exports = __webpack_public_path__ + "static/img/brilliant-screen2-1x.39a069e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brilliant-screen2-1x.jpg
// module id = 5d3w
// module chunks = 0